import * as React from 'react';
import { FailureModeCategoryTemplate } from './failureModeCategoryTemplate.slice';
import { useEffect, useState } from 'react';
import { isStringNullOrEmpty } from '../Annotation/AnnotationForm/Utils';
import { Button, Form, Input, Modal } from 'antd';
import styles from './FailureModeCategoryTemplate.module.scss';
export interface IFailureModeCategoryTemplateFormProps {
  loading: boolean;
  selectedFailureModeCategoryTemplate?: FailureModeCategoryTemplate;
  onHideModal: () => void;
  onSubmit: (template: FailureModeCategoryTemplate) => void;
}

export function FailureModeCategoryTemplateForm(props: IFailureModeCategoryTemplateFormProps) {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (props.selectedFailureModeCategoryTemplate) {
      setCode(props.selectedFailureModeCategoryTemplate.code);
      setName(props.selectedFailureModeCategoryTemplate.name);
      setDescription(props.selectedFailureModeCategoryTemplate.description);
    }
    return () => {
      setCode('');
      setName('');
      setDescription('');
    };
  }, [props.selectedFailureModeCategoryTemplate]);

  const handleSubmit = () => {
    const model: FailureModeCategoryTemplate = {
      id: props.selectedFailureModeCategoryTemplate?.id,
      code,
      name,
      description,
      canDelete: false,
      canUpdate: false,
      deprecated: false
    };
    props.onSubmit(model);
  };

  const disabled = isStringNullOrEmpty(code) || isStringNullOrEmpty(name);
  const canRename =
    !props.selectedFailureModeCategoryTemplate || (props.selectedFailureModeCategoryTemplate && props.selectedFailureModeCategoryTemplate.canUpdate);

  return (
    <Modal
      title='Failure Mechanism Template'
      visible={true}
      onCancel={props.onHideModal}
      footer={[
        <Button key='save' onClick={handleSubmit} loading={props.loading} disabled={disabled}>
          Save
        </Button>,
        <Button key='back' onClick={props.onHideModal}>
          Cancel
        </Button>
      ]}
    >
      <div>
        <Form.Item label='Code' className={styles.antFormItem} required>
          <Input readOnly={!canRename} placeholder='Enter code' value={code} onChange={e => setCode(e.target.value)} />
        </Form.Item>
        <Form.Item label='Name' className={styles.antFormItem} required>
          <Input readOnly={!canRename} placeholder='Enter name' value={name} onChange={e => setName(e.target.value)} />
        </Form.Item>
        <Form.Item label='Description' className={styles.antFormItem}>
          <Input.TextArea
            placeholder='Enter description'
            value={description}
            onChange={e => {
              setDescription(e.target.value);
            }}
          />
        </Form.Item>
      </div>
    </Modal>
  );
}
